<img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo" *ngIf="this.isEmbed === false">

<div class="iwg-form-dialog" [class]="{'iwg-dialog-half-size': (selectedStepIndex == 0 || selectedStepIndex == 3 || 
     (selectedStepIndex == 1 && (step2.line_items == null || step2.line_items?.length == 0)) || 
     (selectedStepIndex == 2 && (step3.attachments == null || step3.attachments?.length == 0)))}">
    <div class="md-toolbar-tools d-flex md-theme m-0 p-3">
        <h2 class="m-0 toolbartitle">
            Contractor Invoice
        </h2>
        <span class="flex"></span>
        <span *ngIf="selectedStepIndex <= 3">Step {{selectedStepIndex + 1}} of {{numberOfSteps}}</span>
        <span *ngIf="selectedStepIndex > 3">Review & Submit</span>
    </div>
    <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading" style="position: absolute"></mat-progress-bar>
    <mat-dialog-content style="overflow: auto;padding:0px;width: 100%;">
        <div class="vista-popup-height">
            <div class="d-flex layout-row" style="height: 100%;">
                <div class="d-flex layout-column flex md-padding w-100"
                    style="height:100%;overflow-y: auto; box-sizing: border-box;padding: 0px 0px 0px 25px;">
                    <mat-tab-group [(selectedIndex)]="selectedStepIndex" class="header-less-tabs">
                        <mat-tab label="step 1">
                            <h3 class="mat-header"> Invoice Setup</h3>
                            <form name="vendorInvoiceStep1" #vendorInvoiceStep1="ngForm">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                       
                                        <mat-select name="assignments" #assignments="ngModel" placeholder="Select Engagement"
                                            [(ngModel)]="step1.selectedAssignmentSimple" (openedChange)="onOpen($event)"
                                            [required]="!preselectedAssignmentId"
                                            (selectionChange)="onSelectedAssignmentChange($event)">
                                            <mat-option
                                                *ngIf="(assignmentsSimple === null || !assignmentsSimple.length)"
                                                class="minh88" disabled>
                                                <div class="select-placeholder-container">
                                                  
                                                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                                                </div>
                                            </mat-option>
                                            <ng-container *ngFor="let assignment of assignmentsSimple">
                                                
                                                <mat-option [value]="assignment"
                                                    *ngIf="assignment.StatusID == 5 && assignment.IsiWorkGlobalPartner == true">
                                                    {{assignment.Title}}
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>

                                    </mat-form-field>
                                    <mat-icon
                                        matTooltip="Invoices must be based on active engagements. Please select the applicable engagement."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                    <mat-error *ngIf="!assignments.valid && assignments.touched">Required</mat-error>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Invoice Title</mat-label>
                                        <input matInput name="title" [(ngModel)]="step1.title" #Ctitle="ngModel"
                                            maxlength="200" required>

                                    </mat-form-field>
                                    <mat-icon matTooltip="Provide a title with enough context to help you track it."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>

                                    <mat-error *ngIf="!Ctitle.valid && Ctitle.touched">Required</mat-error>

                                </div>
                                <div >
                                    <div >
                                        <div class="md-input-container flex" fxFlex="100%" style="position:relative">
                                            <mat-form-field class="mat-form-withtooltip" fxFlex="40%">
                                                <mat-label>Invoice Number</mat-label>
                                                <input matInput name="invoice_number" [(ngModel)]="step1.invoice_number"
                                                    #invoice_number="ngModel" name="invoice_number" maxlength="200"
                                                    required>
                                                <span flex="auto" style="flex: auto"></span>
                                            </mat-form-field>
                                            <mat-icon fxFlex="10%" style="padding-top: 16px;"
                                                matTooltip=" Enter the invoice tracking number here. Any form of tracking identifier is acceptable."
                                                matTooltipPosition="above"
                                                class="ng-scope md-iwgNavbar-theme material-icons">help
                                            </mat-icon>
                                            <mat-error *ngIf="!invoice_number.valid && invoice_number.touched" style="position: absolute;bottom:0;">Required
                                            </mat-error>
                                       
                                        <ng-container  *ngIf="step1.is_show_pay_period">
                                            <mat-datepicker-toggle fxFlex="10%" style="vertical-align: super" matSuffix
                                                                   [for]="picker"></mat-datepicker-toggle>
                                            <mat-form-field [floatLabel]="'always'" class="mat-form-withtooltip" fxFlex="30%"
                                                            >
                                                <mat-label>Delivery Date</mat-label>
                                                <input name="pay_period" #pay_period="ngModel"
                                                       [(ngModel)]="step1.pay_period" placeholder="Select" matInput
                                                       [matDatepicker]="picker" required>
                                                <mat-datepicker-toggle matSuffix [for]="picker">
                                                    <mat-icon matDatepickerToggleIcon  style="cursor: pointer;font-size: 25px;line-height: 20px;">arrow_drop_down</mat-icon>
                                                </mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>

                                            </mat-form-field>

                                            <mat-icon style="padding-top: 10px;" fxFlex="10%"
                                                      matTooltip="  Provide the date on which services were complete for this invoice."
                                                      matTooltipPosition="above"
                                                      class="ng-scope md-iwgNavbar-theme material-icons">
                                                help
                                            </mat-icon>
                                            <mat-error *ngIf="!pay_period?.valid && pay_period?.touched" style="position: absolute;bottom:0;left:60%">
                                                Required
                                            </mat-error>
                                        </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div layout>
                                    <div class="md-input-container">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>Notes</mat-label>
                                            <textarea matInput [(ngModel)]="step1.notes" rows="3" name="notes"
                                                maxlength="2000" class="m-top"></textarea>

                                        </mat-form-field>
                                        <mat-icon class="md-iwgNavbar-theme"
                                            matTooltip="Enter any notes you'd like to appear relevent to this invoice during the appoval process."
                                            matTooltipPosition="above">help
                                        </mat-icon>
                                    </div>
                                </div>
                            </form>
                        </mat-tab>

                        <mat-tab label="step 2">
                            <div layout id="AnchorLineItemEntry"></div>
                            <h3 style="font-weight: 400;margin-top: 18px;font-size: 18px;">Invoice Line Items</h3>
                            <form name="vendorInvoiceStep2" #vendorInvoiceStep2="ngForm">
                                <div class="md-input-container flex">
                                    <mat-form-field class="mat-form-withtooltip" 
                                     fxFlex.lt-sm="88">
                                        <mat-label>Title</mat-label>
                                        <input matInput name="new_title" [(ngModel)]="step2.new_title"
                                            #new_title="ngModel" name="new_title" maxlength="2000" required>

                                    </mat-form-field>
                                    <mat-icon matTooltip="Descriptive title for this line item."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                    <mat-error *ngIf="!new_title.valid && new_title.touched">Required</mat-error>

                                </div>
                                <div fxLayout="row" fxLayout-xs="column" style="max-height: 50px;" class="{{ hasLevel2 ? 'chargeTypeWidthTwoColum': 'chargeTypeWidthOneColum' }}">
                                    <div class="md-input-container flex" style="margin-top:0px" *ngIf="hasLevel1">
                                       
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>{{Label1}}</mat-label>
                                            <mat-select [(ngModel)]="step2.selectProjectLevel1" required
                                                [compareWith]="objectComparison" name="selectProjectLevel1"
                                                (selectionChange)="onProjectLevel1Change($event)">
                                                <mat-option [value]="projectCode"
                                                    *ngFor="let projectCode of ProjectLevel1Codes">
                                                    {{projectCode.ProjectTitle}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="md-input-container flex" style="margin-top:0px" *ngIf="hasLevel2">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>{{Label2}}</mat-label>
                                            <mat-select flex [(ngModel)]="step2.selectProjectLevel2" required
                                                [compareWith]="objectComparison" name="selectProjectLevel2"
                                                (selectionChange)="onProjectLevel2Change($event)">
                                                <mat-option [value]="projectCode"
                                                    *ngFor="let projectCode of ProjectLevel2Codes">
                                                    {{projectCode.ProjectTitle}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div fxLayout="row" layout-xs="column" style="max-height: 90px;">
                                    <div class="md-input-container flex" style="margin: 0px">
                                        <app-charge-select layout="row" [(ngModel)]="step2.selectedCharge"
                                            helptext="Select the appropriate type of charge."
                                            [preselectedItemId]="step2.selectedCharge?.ID"
                                            (selectionChange)="ChargeChange($event)" [required]="true"
                                            #chargeSelect
                                            name="selectedCharge" [assignmentid]="step1.selectedAssignmentId"
                                            [allocationid]="step2.selectProjectLevel1?.ID"
                                            [allocationid2]="step2.selectProjectLevel2?.ID"
                                            [disabled]="!step2.chargeTypeDropDownEnabled">
                                        </app-charge-select>
                                    </div>
                                </div>
                                <div fxLayout="row" layout-xs="column" style="max-height: 60px;">
                                    <div class="md-input-container flex" *ngIf="step2.show_unit" style="width: 30%;">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>{{step2.unit_label_plural}}</mat-label>
                                            <input matInput name="new_units" [(ngModel)]="step2.new_units"
                                                #new_units="ngModel" (input)="onNewUnit()"
                                                [disabled]="step2.unit_disabled" type="number" min="0.01"
                                                name="new_units" maxlength="200" required>
                                        </mat-form-field>
                                        <mat-error
                                            *ngIf="!step2.unit_disabled && !new_units.valid && new_units.touched">
                                            Required</mat-error>
                                    </div>

                                    <div class="md-input-container flex" *ngIf="step2.show_rate" style="width: 30%;">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label *ngIf="!step2.rate_disabled" >Charge<span *ngIf="step2.show_unit">/ {{step2.unit_label}}
                                                </span></mat-label>
                                                <mat-label *ngIf="step2.rate_disabled" >Charge<span *ngIf="step2.show_unit">/ {{step2.unit_label}}
                                                </span> *</mat-label>
                                            <input matInput name="new_rate" [(ngModel)]="step2.new_rate"
                                                #new_rate="ngModel" [disabled]="step2.rate_disabled" type="number"
                                                min="0.01" (input)="onNewRate()" name="new_rate" [maxlength]="200"
                                                required>
                                        </mat-form-field>
                                        <mat-error *ngIf="!step2.rate_disabled && !new_rate.valid && new_rate.touched">
                                            Required</mat-error>
                                    </div>
                                    <input [(ngModel)]="step2.new_total" type="text" [min]="0.01" [hidden]="true"
                                        name="new_total" [disabled]="step2.new_total_disabled">


                                    <div class="md-input-container flex" style="width: 30%;">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>Bill Amount</mat-label>
                                            <input matInput name="new_total_mask" [(ngModel)]="step2.new_total_mask"
                                                #new_total_mask="ngModel" [disabled]="step2.new_total_disabled"
                                                type="text" [min]="0.01">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div layout>
                                    <div class="md-input-container flex">
                                        <mat-form-field class="mat-form-withtooltip" fxFlex.lt-sm="88">
                                            <mat-label>Notes</mat-label>
                                            <textarea matInput [(ngModel)]="step2.new_notes" rows="3" name="new_notes"
                                                class="m-top" [maxlength]="2000"></textarea>

                                        </mat-form-field>
                                        <mat-icon style="margin-top:3.5rem"
                                            matTooltip=" Enter any notes you'd like to appear relevent to this line item during the appoval process."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help
                                        </mat-icon>
                                    </div>
                                </div>
                                  <div layout="column"
                                    *ngIf="selectedStepIndex == 1 && step2.line_items != null && step2.line_items.length != 0"
                                    fxHide fxShow.lt-sm>
                                    <h3
                                        style="font-weight: 400; margin-top: 18px; font-size: 18px;">
                                        Review Line Item Summary</h3>

                                    <div class="iwg-widget-box-card" *ngFor="let item of step2.line_items"
                                        style="border-bottom: 1px solid #9a9a9a;">
                                        <p>
                                            <mat-label class="iwg-regular-label">Title: {{item.Title}}</mat-label>
                                        </p>
                                        <p *ngIf="item.ProjectCode != null && item.ProjectCode != ''">
                                            <mat-label class="iwg-regular-label">
                                                {{Label1}}: {{item.ProjectCode | blank}}
                                            </mat-label>
                                        </p>
                                        <p *ngIf="item.ProjectCodeLevel2 != null && item.ProjectCodeLevel2 != ''">
                                            <mat-label class="iwg-regular-label">{{Label2}}:
                                                {{item.ProjectCodeLevel2 | blank}}</mat-label>
                                        </p>
                                        <p>
                                            <mat-label class="iwg-regular-label">
                                                {{ ((item.UnitLabelSingular == '') ? (item.Rate != '' ? (item.ChargeTitle + ': ' + EngagementCurrencySymbol + item.Rate+ ' ' + EngagementCurrencyCode) : 'Variable Charge') : (item.ChargeTitle + ': ' + item.Units + ' ' + item.UnitLabelPlural + ' @' + EngagementCurrencySymbol + item.Rate + ' '+ EngagementCurrencyCode + '/' + item.UnitLabelSingular))| blank}}
                                            </mat-label>
                                        </p>
                                        
                                        <p>
                                            <mat-label class="iwg-regular-label">
                                                Bill
                                                Amount:
                                                {{ EngagementCurrencySymbol + (item.Total | number : '1.2-2') + ' ' + EngagementCurrencyCode }}
                                            </mat-label>
                                        </p>

                                        <p>
                                            <mat-label class="iwg-regular-label">Notes: {{item.Notes}}</mat-label>
                                        </p>

                                        <div class="vista-action-btn">
                                            <button mat-button class="vista-dialogbtn raiced-btn"
                                                style="margin-bottom: 10px;" (click)="deleteInvoiceLineItem(item.ID)">
                                                Remove
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="step 3">
                            <form name="vendorInvoiceStep3" #vendorInvoiceStep3="ngForm">
                                <h3 style="font-weight: 400;font-size: 18px">Add New Attachment</h3>
                                <div layout style="margin-bottom:10px">
                                    <app-file-upload [upload-url]="'/Api/VendorInvoices/'+existingVendorInvoiceId"
                                        [file-property]="'file_upload'" [uploaded-file-name]="step3.attachmentFileName">
                                    </app-file-upload>
                                </div>
                                <div layout>
                                    <div class="md-input-container flex">
                                        <mat-form-field class="mat-form-withtooltip" fxFlex.lt-sm="88">
                                            <mat-label>Description</mat-label>
                                            <input matInput name="description" [(ngModel)]="step3.description"
                                                #description="ngModel" autocomplete="off" [required]="isFileUploaded">
                                        </mat-form-field>
                                        <mat-icon [matTooltip]="'Provide a description for the attachment.'"
                                            matTooltipPosition="above" style="padding-top: 1rem;"
                                            class="ng-scope md-iwgNavbar-theme material-icons">
                                            help
                                        </mat-icon>
                                        <mat-error *ngIf="!description.valid && description.touched">Required
                                        </mat-error>
                                    </div>
                                </div>
                                <div layout>
                                    <button mat-button class="vista-dialogbtn" [disabled]="!canProceed()"
                                        (click)="nextStep(false)">
                                        Add Attachment
                                    </button>
                                </div>
                               
                            </form>
                            <div layout="column" fxHide fxShow.lt-sm style="overflow-y: auto;"
                            *ngIf="selectedStepIndex == 2 && step3.attachments.length != 0">
                            <h3 style="font-weight: 400; margin-top: 18px; font-size: 18px;">Review
                                Attachment Summary</h3>
        
                            <div class="iwg-widget-box-card" *ngFor="let item of step3.attachments">
                                <p>
                                    <mat-label class="iwg-regular-label">Filename: {{item.Name}}</mat-label>
                                </p>
                                <p>
                                    <mat-label class="iwg-regular-label">Description: {{item.Description}}</mat-label>
                                </p>
        
                               
        
                                <div style="border-bottom: 1px solid #9a9a9a;">
                                    <button [disabled]="isLoading" mat-icon-button (click)="downloadFile(item.ID)">
                                        <mat-icon class="inputassignicon">file_download</mat-icon>
                                    </button>
                                    <button mat-button style="margin-bottom: 10px;" class="vista-dialogbtn raiced-btn" (click)=" deleteAttachment(item.ID)">
                                        Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                        </mat-tab>
                        <mat-tab label="review">
                            <h3 style="font-weight: 400; margin-top: 18px; font-size: 18px;">Review
                                Invoice Details</h3>
                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 1: Invoice Setup</span><span flex></span><a
                                        (click)="selectedStepIndex=0" class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <mat-label class="iwg-regular-label">Engagement Title</mat-label>
                                    <p class="iwg-regular-value">
                                        {{step1.selectedAssignmentSimple ? step1.selectedAssignmentSimple.Title : ''}}
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <mat-label class="iwg-regular-label">Invoice Title</mat-label>
                                    <p class="iwg-regular-value">{{step1.title}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <mat-label class="iwg-regular-label">Invoice Number</mat-label>
                                    <p class="iwg-regular-value">{{step1.invoice_number}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.is_show_pay_period">
                                    <mat-label class="iwg-regular-label">Delivery Date</mat-label>
                                    <p class="iwg-regular-value">{{ step1.pay_period ? (step1.pay_period | date) : ""}}
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <mat-label class="iwg-regular-label">Notes</mat-label>
                                    <p class="iwg-regular-value">{{step1.notes}}</p>
                                </div>
                            </div>
                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 2: Invoice Line Items</span><span
                                        flex></span>
                                    <a (click)="selectedStepIndex=1" class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div *ngFor="let item of step2.line_items">
                                    <div class="iwg-widget-box-card">
                                        <mat-label class="iwg-regular-label">Title:</mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:370px; overflow-wrap: break-word;white-space: normal;">
                                            {{item.Title}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card"
                                        *ngIf="item.ProjectCode != null && item.ProjectCode != ''">
                                        <mat-label *ngIf="item.ProjectCode != null && item.ProjectCode != ''"
                                            class="iwg-regular-label">{{Label1}}: </mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:370px; overflow-wrap: break-word;white-space: normal;">
                                            {{item.ProjectCode | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                        *ngIf="item.ProjectCodeLevel2 != null && item.ProjectCodeLevel2 != ''">
                                        <mat-label
                                            *ngIf="item.ProjectCodeLevel2 != null && item.ProjectCodeLevel2 != ''"
                                            class="iwg-regular-label">{{Label2}}: </mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:370px; overflow-wrap: break-word;white-space: normal;">
                                            {{item.ProjectCodeLevel2 | blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card">
                                        <mat-label class="iwg-regular-label">
                                            {{((item.UnitLabelSingular == '') ? (item.Rate != '' ? item.ChargeTitle + ': ' : 'Variable Charge') : (item.ChargeTitle + ': '))}}
                                        </mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            {{((item.UnitLabelSingular == '') ? (item.Rate != '' ? (EngagementCurrencySymbol + item.Rate + ' ' + EngagementCurrencyCode) : 'Variable Charge') : (item.Units + ' ' + item.UnitLabelPlural + ' @' + EngagementCurrencySymbol + item.Rate + ' ' + EngagementCurrencyCode + '/' + item.UnitLabelSingular))| blank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <mat-label class="iwg-regular-label">Bill Amount:</mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            {{ EngagementCurrencySymbol + (item.Total | number : '1.2-2') + ' ' + EngagementCurrencyCode }}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <mat-label class="iwg-regular-label">Notes:</mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:370px; overflow-wrap: break-word;white-space: normal;">
                                            {{item.Notes}}</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 3: Attachments</span><span flex></span>
                                    <a (click)="selectedStepIndex=2" class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div *ngFor="let item of step3.attachments">
                                    <div class="iwg-widget-box-card">
                                        <mat-label class="iwg-regular-label">Description:</mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:370px; overflow-wrap: break-word;white-space: normal;">
                                            {{item.Description}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <mat-label class="iwg-regular-label">Description File:</mat-label>
                                        <p class="iwg-regular-value"
                                            style="width:95%; overflow-wrap: break-word;white-space: normal;">
                                            {{item.Name}}
                                            <button [disabled]="isLoading" mat-icon-button aria-label="Download" style="line-height:20px;"
                                                class="inputassignicon" (click)="downloadFile(item.ID)">
                                                <mat-icon>file_download</mat-icon>
                                            </button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                 <div class="d-flex layout-column flex md-padding w-100" fxShow fxHide.lt-sm 
                  style="overflow-y: auto;"
                    *ngIf="selectedStepIndex == 1 && step2.line_items != null && step2.line_items.length != 0"
                   >
                    <h3 style="font-weight: 400; margin-top: 18px; font-size: 18px;">Review Line
                        Item Summary</h3>

                    <div class="iwg-widget-box-card" *ngFor="let item of step2.line_items">
                        <p>
                            <mat-label class="iwg-regular-label">Title: {{item.Title}}</mat-label>
                        </p>
                        <p>
                            <mat-label *ngIf="item.ProjectCode != null && item.ProjectCode != ''"
                                class="iwg-regular-label">{{Label1}}: {{item.ProjectCode | blank}}</mat-label>
                        </p>
                        <p>
                            <mat-label *ngIf="item.ProjectCodeLevel2 != null && item.ProjectCodeLevel2 != ''"
                                class="iwg-regular-label">{{Label2}}: {{item.ProjectCodeLevel2 | blank}}</mat-label>
                        </p>
                        <p>
                            <mat-label class="iwg-regular-label">
                                {{((item.UnitLabelSingular == '') ? (item.Rate != '' ? (item.ChargeTitle + ': ' + EngagementCurrencySymbol + item.Rate + ' ' + EngagementCurrencyCode) : 'Variable Charge') : (item.ChargeTitle + ': ' + item.Units + ' ' + item.UnitLabelPlural + ' @' + EngagementCurrencySymbol + item.Rate + ' ' + EngagementCurrencyCode + '/' + item.UnitLabelSingular))| blank}}
                            </mat-label>
                        </p>
                        <p>
                            <mat-label class="iwg-regular-label">Bill
                                Amount:
                                {{ EngagementCurrencySymbol + (item.Total | number : '1.2-2') + ' ' + EngagementCurrencyCode }}
                            </mat-label>
                        </p>
                        <p>
                            <mat-label class="iwg-regular-label">Notes: {{item.Notes}}</mat-label>
                        </p>
                        <div style="border-bottom: 1px solid #9a9a9a;">
                            <button mat-button class="vista-dialogbtn raiced-btn" style="margin-bottom: 10px;"
                                (click)="deleteInvoiceLineItem(item.ID)">
                                Remove
                            </button>
                        </div>
                    </div>
                    <div id="AnchorLineItemReview"></div>
                </div>
                <div class="d-flex layout-column flex md-padding w-100" fxShow fxHide.lt-sm style="overflow-y: auto;"
                    *ngIf="selectedStepIndex == 2 && step3.attachments.length != 0">
                    <h3 style="font-weight: 400; margin-top: 18px; font-size: 18px;">Review
                        Attachment Summary</h3>

                    <div class="iwg-widget-box-card" *ngFor="let item of step3.attachments">
                        <p>
                            <mat-label class="iwg-regular-label">Filename: {{item.Name}}</mat-label>
                        </p>
                        <p>
                            <mat-label class="iwg-regular-label">Description: {{item.Description}}</mat-label>
                        </p>

                       

                        <div style="border-bottom: 1px solid #9a9a9a;">
                            <button [disabled]="isLoading" mat-icon-button (click)="downloadFile(item.ID)">
                                <mat-icon class="inputassignicon">file_download</mat-icon>
                            </button>
                            <button mat-button style="margin-bottom: 10px;" class="vista-dialogbtn raiced-btn" (click)=" deleteAttachment(item.ID)">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="justify-fend">
        <div fxLayout="row" fxLayoutAlign="space-between center" style="overflow:auto; width: 100%; padding-bottom:0.7rem" [ngClass]="{'mobile-space-btn': ((selectedStepIndex == 2 && step3.attachments.length != 0) ||
                (selectedStepIndex == 1 && step2.line_items != null && step2.line_items.length != 0))}" class="mobile-responsive">

            <div fxLayoutAlign="start center">
                <button [disabled]="isFileUploadInProgress" *ngIf="selectedStepIndex != 0" mat-button
                    (click)="prevStep()">« Back</button>

            </div>

            <div fxLayout="row" fxLayoutAlign="end center">
                <button mat-button mat-raised-button color="primary" class="vista-dialogbtn"
                    *ngIf="selectedStepIndex == 1" [disabled]="!canProceed() || addInprogress"
                    (click)="nextStep(false)">
                    Save Line Item
                </button>

                <button mat-button mat-dialog-close (click)="cancel()" [disabled]="isFileUploadInProgress"
                    *ngIf="selectedStepIndex != 4">
                    <span *ngIf="selectedStepIndex == 0">Cancel</span>
                    <span *ngIf="selectedStepIndex != 0"><span class="mobile-hide">Save as</span>&nbsp;<span>Draft</span></span>
                </button>

                <button mat-button (click)="saveAsDraft()" *ngIf="selectedStepIndex == 4">
                    <span class="mobile-hide">Save as</span>&nbsp;<span>Draft</span>
                </button>
               
                <button mat-button class="vista-dialogbtn" *ngIf="selectedStepIndex != 3" [disabled]="((!canProceed() && selectedStepIndex == 0) 
                || (selectedStepIndex == 2 && isFileUploaded)        
                || (!canProceedSaveAndContinue())) 
                        || (!LineItemsAdded && selectedStepIndex == 1) 
                        || (isFileUploadInProgress) " (click)="nextStep(true)" hide-xs> <span class="mobile-hide">Save &</span>&nbsp;<span>Continue</span>
                </button>


                <button mat-button *ngIf="selectedStepIndex != 3" [disabled]="((!canProceed() && selectedStepIndex == 0) 
                    || (selectedStepIndex == 2 && isFileUploaded) 
                    || (!canProceedSaveAndContinue())) 
                    || (!LineItemsAdded && selectedStepIndex == 1) 
                    || (isFileUploadInProgress) " (click)="nextStep(true)" fxHide.gt-xs fxHide>
                    Continue
                </button>

                <button mat-button class="vista-dialogbtn" (click)="submit()" *ngIf="selectedStepIndex == 3">
                    Submit
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</div>
